import { HttpService } from "@/utils/request";
/**
 * 保存广告信息
 * @param query
 * @returns {*}
 */
export function saveMediaDelivery(query) {
    return HttpService({
        url: "/equipment/saveAdvertisement",
        method: "POST",
        data: query
    });
}
/**
 * 获取广告列表
 * @param query
 * @returns {*}
 */
export function getMediaDeliveryList(query) {
    return HttpService({
        url: "/equipment/listAdvertisement",
        method: "POST",
        data: query
    });
}
/**
 * 获取广告详情
 * @param query
 * @returns {*}
 */
export function getMediaDeliveryInfo(query) {
    return HttpService({
        url: "/equipment/detailAdvertisement",
        method: "POST",
        data: query
    });
}
/**
 * 广告投放
 * @param query
 * @returns {*}
 */
export function putMediaDelivery(query) {
    return HttpService({
        url: "/equipment/saveEquipmentAdvertisements",
        method: "POST",
        data: query
    });
}
/**
 * 广告投放信息
 * @param query
 * @returns {*}
 */
export function getMediaDeliveryDetail(query) {
    return HttpService({
        url: "/equipment/detailEquipmentAdvertisements",
        method: "POST",
        data: query
    });
}
/**
 * s删除
 * @param query
 * @returns {*}
 */
export function deletlMediaDeliveryDetail(query) {
    return HttpService({
        url: "/equipment/deleteEquipmentAdvertisements",
        method: "POST",
        data: query
    });
}